const cssStyles = () => `
.GrowthUnauthToast__container {
  margin: 60px 0px;
}
`;

export default cssStyles;
